module.exports = __webpack_public_path__ + "static/img/011.2e0b483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperator/011.png
// module id = UNRw
// module chunks = 0